export default "__VITE_ASSET__DfxcvrVM__"